module.exports = __webpack_public_path__ + "img/DE.85f98c37.svg";